<div class="modal-content" *ngIf="loaded">
  <div class="modal-header text-center p-3">
    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
    <h4 class="modal-title w-100">{{ 'baryApp.quotations.moderatorModal.title' | translate }}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="alert alert-info">
          <p jhiTranslate="baryApp.quotations.moderatorModal.text1">
            Pour répondre au besoin exprimé par votre client vous pouvez lui proposer un tarif et lui indiquer conditions dans lesquelles vous pouvez exécuter son ordre de
            transport. Votre client recevra alors un courriel et le devis sera en attente d'une réponse de sa part dans la limite de la date d'acceptation que vous avez renseignée.
          </p>
          <p jhiTranslate="baryApp.quotations.moderatorModal.text2">
            Vous pouvez également refuser de prendre en charge ces marchandises, votre client recevra alors un courriel et sa demande sera archivée
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <jhi-transport-card [transport]="quotation"></jhi-transport-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div *ngIf="lastEstimate && lastEstimate.errorMessages && lastEstimate.errorMessages.length > 0" class="col-12 alert alert-danger" role="alert">
          <span class="m-2">{{ 'estimation-tunnel.invalidTransport.errorTitleAlert' | translate }}</span>
          <ul>
            <li *ngFor="let message of lastEstimate.errorMessages">{{ message }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col text-left">
        <form class="mt-2 text-left" name="form" role="form" (ngSubmit)="submit()" (keydown.enter)="submit()" [formGroup]="quotationForm">
          <div class="col-12">
            <div class="row">
              <div class="col-8">
                <div class="form-group input mb-2">
                  <jhi-bary-date-picker
                    [title]="'baryApp.quotations.moderatorModal.pickupDate' | translate"
                    [label]="'baryApp.quotations.moderatorModal.pickupDate' | translate"
                    [control]="getControl('pickupDate')"
                    [disabled]="false"
                    [isDisableWeekends]="false"
                    [isPickup]="true"
                    [options]="pickupOptions"
                  ></jhi-bary-date-picker>
                </div>
                <div class="alert alert-danger small" *ngIf="quotationForm?.errors?.['errorDateForm']">
                  {{ 'baryApp.quotations.moderatorModal.errorDatePickup' | translate }}
                </div>
                <div class="input">
                  <jhi-bary-date-picker
                    [title]="'baryApp.quotations.moderatorModal.deliveryDate' | translate"
                    [label]="'baryApp.quotations.moderatorModal.deliveryDate' | translate"
                    [control]="getControl('deliveryDate')"
                    [disabled]="false"
                    [isDisableWeekends]="false"
                    [options]="deliveryOptions"
                  ></jhi-bary-date-picker>
                </div>
                <div class="form-group price-ht input">
                  <div class="alert alert-info small" jhiTranslate="baryApp.quotations.moderatorModal.infoPrice"></div>
                  <jhi-bary-input-price
                    [label]="'baryApp.quotations.moderatorModal.priceHT' | translate"
                    [control]="getControl('quotationBasePrice')"
                    data-id-cypress="prix-quotation"
                    id="field_quotationBasePrice"
                  ></jhi-bary-input-price>
                </div>
                <div class="form-group input">
                  <jhi-bary-date-picker
                    [title]="'baryApp.quotations.moderatorModal.validityDate' | translate"
                    [label]="'baryApp.quotations.moderatorModal.validityDate' | translate"
                    [control]="getControl('quotationValidityDate')"
                    data-id-cypress="date-picker-quotation"
                    [disabled]="false"
                    [isDisableWeekends]="false"
                    [isPickup]="true"
                    [options]="pickupOptions"
                  ></jhi-bary-date-picker>
                  <div *ngIf="getControl('quotationValidityDate').invalid && (getControl('quotationValidityDate').dirty || getControl('quotationValidityDate').touched)">
                    <small class="form-text text-danger" *ngIf="getControl('quotationValidityDate').errors?.required" jhiTranslate="entity.validation.required">
                      This field is required.
                    </small>
                  </div>
                  <div *ngIf="getControl('quotationValidityDate').value && getNbDay(getControl('quotationValidityDate').value) < 7">
                    <small
                      *ngIf="getNbDay(getControl('quotationValidityDate').value) > 0"
                      class="form-text text-warning mt--1"
                      jhiTranslate="baryApp.quotations.moderatorModal.shortValidityDate"
                      [translateValues]="{ nbDay: getNbDay(getControl('quotationValidityDate').value) }"
                    >
                      Warning, you are set a short validity date
                    </small>
                    <small
                      *ngIf="getNbDay(getControl('quotationValidityDate').value) == 0"
                      class="form-text text-warning mt--1"
                      jhiTranslate="baryApp.quotations.moderatorModal.sameDayValidityDate"
                      [translateValues]="{ nbDay: getNbDay(getControl('quotationValidityDate').value) }"
                    >
                      Warning, you are set a same day validity date
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-4 align-content-center d-flex flex-wrap justify-content-center" *ngIf="getControl('quotationBasePrice').value">
                <jhi-estimation-price [showButton]="false" [lastEstimate]="lastEstimate"></jhi-estimation-price>
              </div>
            </div>
          </div>
          <div class="text-center">
            <jhi-bary-button
              class="mr-2"
              [color]="'white'"
              [label]="'baryApp.quotations.moderatorModal.deny' | translate"
              (click)="handleClick({ second: true })"
            ></jhi-bary-button>
            <jhi-bary-button
              [color]="'secondary'"
              [disabled]="quotationForm.invalid"
              [label]="'baryApp.quotations.moderatorModal.send' | translate"
              data-id-cypress="valider-quotation"
              (click)="submit()"
            ></jhi-bary-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
